import React from 'react';

import { RenderProps as RouteWithSearchProps } from 'lib/react-router/route-with-search';

import CollectionSlugLoader from '../collection-slug-loader/collection-slug-loader';
import CollectionEdit from './collection-edit';

interface Params {
    username: string;
    slug: string;
}

class CollectionEditLoader extends React.PureComponent<RouteWithSearchProps<Params, {}>> {
    render() {
        return <CollectionSlugLoader {...this.props}>{CollectionEdit as any}</CollectionSlugLoader>;
    }
}

export default CollectionEditLoader;
